export const FINITE_SCROLL_OFFSET = 1000;
export const FINITE_SCROLL_NUM = 5;
